import axios from "axios";
import { API_URL, REF_BO } from "../../config";
import { AUTH_TYPES } from "../reducers/authReducers";
import tools from "../../helpers/tools";
import jwt_decode from "jwt-decode";
import { ERROR_TYPES } from "../reducers/errorReducers";

export const authActions = (state, dispatch) => {
  function loginUser(userData) {
    // fetch api

    axios
      .post(API_URL + "auth/login/" + REF_BO, userData, {
        withCredentials: true,
      })
      .then((res) => {
        // Save to localStorage
        const token = res.data;
        // Set token to ls
        localStorage.setItem("jwtTokenBo", token);
        // Set token to Auth header
        //tools.setAuthToken(token);
        // Set current user

        console.log("jwt_decode(token)", jwt_decode(token));
        /*dispatch({
          type: AUTH_TYPES.SET_CURRENT_USER,
          payload: jwt_decode(token),
        });*/
        setTimeout(() => {
          window.location.reload(); // Recharge la page pour déclencher le password manager
        }, 2000);
      })
      .catch((err) => {
        tools.filterError(err, dispatch, AUTH_TYPES.LOAD_CURRENT_USER);
      });
  }

  function logoutUser() {
    // Remove token from localStorage

    localStorage.removeItem("jwtTokenBo");
    // Remove auth header for future requests
    axios.get(API_URL + "auth/logout").catch((err) => console.log(err));
    // Set current user to {} which will set isAuthenticated to false
    dispatch({ type: AUTH_TYPES.CLEAR_CURRENT_USER, payload: {} });
    dispatch({ type: ERROR_TYPES.CLEAR_ERRORS, payload: {} });
  }

  return {
    loginUser,
    logoutUser,
  };
};
